import axios from 'axios';
import {  getToken } from '../servicios/ServicioManejadorToken';
import { BASE_URL } from '../servicios/ServicioConstantes';

var instanciaAxios = axios.create({
  baseURL: BASE_URL
});

instanciaAxios.interceptors.request.use(function (config) {
  return getToken().then(response => {
    let token = response;
    if (token) {
      if (config.method !== 'OPTIONS') {
        let autorizacion = token;
        config.headers.authorization = autorizacion;
      }
    }
    document.body.classList.add('loading-indicator');
    return Promise.resolve(config);
  })
}, function (error) {
  document.body.classList.remove('loading-indicator');
  return Promise.reject(error);
});

instanciaAxios.interceptors.response.use(function (response) {
  document.body.classList.remove('loading-indicator');
  return response;
}, function (error) {
  document.body.classList.remove('loading-indicator');
  return Promise.reject(error);
});

export default instanciaAxios;